import LessonOverviewModalContainer from '../../../containers/LessonsPage/LessonOverviewModalContainer';
import TrackOverviewModalContainer from '../../../containers/TracksPage/TrackOverviewModalContainer';
import { NavMarker } from 'react-rhumb';
import { NextPlaylistContent } from './NextPlaylistContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const NextPlaylistContentOverview = ({
  trackId,
  lessonId,
  shortId,
  navMarkerName
}) => {
  const content = /*#__PURE__*/_jsx(NextPlaylistContent, {
    lessonId: lessonId,
    render: ({
      trackId: nextTrackId,
      lessonId: nextLessonId,
      language: nextItemLanguage
    }) => {
      if (nextTrackId) {
        return /*#__PURE__*/_jsx(TrackOverviewModalContainer, {
          allowFullWidthChildren: true,
          language: nextItemLanguage,
          trackId: nextTrackId
        });
      } else if (nextLessonId) {
        return /*#__PURE__*/_jsx(LessonOverviewModalContainer, {
          allowFullWidthChildren: true,
          language: nextItemLanguage,
          lessonId: nextLessonId
        });
      }
      return null;
    },
    shortId: shortId,
    trackId: trackId
  });
  if (navMarkerName) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName,
      children: content
    });
  }
  return content;
};